import { put } from "aws-amplify/api";
import { API_NAME_VELAVU, normalizePromiseError } from "../util/amplify-utils";
import { fetchAuthSession } from "aws-amplify/auth";
export default class VelavuAPIAuthorizeMQTT {
    // This method creates a policy document restricting access to MQTT topics of the given organization,
    // and attaches that policy to the user's cognito federated identity. This allows an authenticated user
    // to use pubsub functionality for real-time location and alert updates.
    async authorizeMQTT() {
        //Get the user's identity ID
        const authSession = await fetchAuthSession();
        const identityID = authSession.identityId;
        if (identityID === undefined) {
            throw new Error("No identity ID available!");
        }
        return normalizePromiseError(put({
            apiName: API_NAME_VELAVU,
            path: `/mqttauth/${identityID}`,
        }).response);
    }
}
//# sourceMappingURL=velavu-api-authorize-mqtt.js.map